module.exports = __webpack_public_path__ + "img/schz1.118fd58e.png";